import { render, staticRenderFns } from "./AuditLogHeader.vue?vue&type=template&id=4745b5fa&"
import script from "./AuditLogHeader.vue?vue&type=script&lang=js&"
export * from "./AuditLogHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/cabcom.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4745b5fa')) {
      api.createRecord('4745b5fa', component.options)
    } else {
      api.reload('4745b5fa', component.options)
    }
    module.hot.accept("./AuditLogHeader.vue?vue&type=template&id=4745b5fa&", function () {
      api.rerender('4745b5fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/AuditLogHeader.vue"
export default component.exports